import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsAuth, getMerchantId } from 'redux/reducers/auth/selectors';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import { EASSpinner } from 'components/EASSpinner';
import { PATHS } from 'routes/constants';

export const HomePage: FC = () => {
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);

	const navigate = useNavigate();

	useEffect(() => {
		if (navigateParams?.code)
			navigate(
				`/auth/code?code=${String(navigateParams?.code ?? '')}&session_state=${String(navigateParams?.session_state ?? '')}`,
			);
		else navigate(PATHS.SHOPS_PAGE);
	});

	return <EASSpinner />;
};
